(function ($) {
    $(document).ready(function () {
        let $logotickerslider = $('.generic-content-slider.slider');

        if ($logotickerslider.length > 0) {
            $logotickerslider.each(function () {
                let $this = $(this);
                $this.slick({
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    autoplay: true,
                    autoplaySpeed: 0,
                    speed: 10000,
                    cssEase: 'linear',
                    arrows: false,
                    dots: false,
                    pauseOnHover: false,
                    variableWidth: true,
                    pauseOnFocus: false,
                    swipe: false,
                    swipeToSlide: false,
                    mobileFirst: true,
                });
            });
        }

        let $gallery = $('.lightbox-gallery-slider');

        if ($gallery.length > 0) {
            $gallery.each(function () {
                var $this = $(this);

                // Get a unique selector for the items inside this gallery
                var galleryId = $this.attr('id');

                $this.slick({
                    arrows: false,
                    slidesToShow: 1,
                    variableWidth: true,
                    adaptiveHeight: false,
                    infinite: false,
                    swipeToSlide: false,
                    swipe: false,
                    dots: true,
                    centerMode: true,
                    autoplay: true,
                    autoplaySpeed: 4000,
                    pauseOnHover: true,
                });

                var lightbox = new SimpleLightbox('#' + galleryId + ' a.lightbox-gallery-slider__item', {
                    // captions: true,
                    // captionsData: 'title',
                    disableRightClick: true,
                    captionDelay: 250,
                    captionSelector: 'self',
                    captionPosition: 'outside',
                    close: true,
                    showCounter: true,
                    animationSlide: false,
                    overlayOpacity: 0.96,
                    closeText: '<i class="fa-solid fa-xmark"></i>',
                    navText: ['<i class="fa-solid fa-chevron-left"></i>', '<i class="fa-solid fa-chevron-right"></i>'],
                });

                // --- Sync Slick when Lightbox opens a slide ---
                lightbox.on('changed.simplelightbox', function (e) {
                    console.log('test', e.srcElement.getAttribute('data-idx'));
                    $this.slick('slickGoTo', e.srcElement.getAttribute('data-idx'));
                });
                lightbox.on('shown.simplelightbox', function (e) {
                    console.log('test', e.srcElement.getAttribute('data-idx'));
                    $this.slick('slickGoTo', e.srcElement.getAttribute('data-idx'));
                    // var indexToGo = -1;

                    // // Find index of clicked image
                    // $items.each(function (i) {
                    //     if ($(this).attr('href') === currentHref) {
                    //         indexToGo = i;
                    //         return false; // break loop
                    //     }
                    // });

                    // if (indexToGo !== -1) {
                    //     $this.slick('slickGoTo', indexToGo);
                    // }
                });

                // --- Optional: Refresh lightbox on slick update ---
                // $this.on('afterChange', function () {
                //     lightbox.refresh(); // Refresh in case new items are added
                // });
            });
        }
    });
})(jQuery);
